import { NgModule } from '@angular/core';
import { EntityDataService, EntityServices } from '@ngrx/data';
import {ProductStockUnitRepository} from "./impl/service/repository/productStockUnit.repository";
import {ProductStockUnitDataService} from "./impl/service/repository/productStockUnitData.service";
import {errorMessages} from "../../../core/error/errorMessages";

@NgModule({
})
export class ProductStockUnitModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: ProductStockUnitRepository,
                dataService: ProductStockUnitDataService) {
        entityDataService.registerServices({
            ProductStockUnit: dataService,
        });

        entityServices.registerEntityCollectionServices({
            ProductStockUnit: repository,
        });
        errorMessages.set('PRODUCT_STOCK_UNIT_EXIT_ALREADY_EXITED', 'Le produit est déjà sorti du stock.');
    }
}

